

















import { Component, Vue } from 'vue-property-decorator';
import Navbar from './Navbar.vue';

@Component({
  name: 'clients-layout',
  components: { Navbar },
})
export default class RightBar extends Vue {
}
